import React from 'react';
import { physicsCalculators } from './ConstantsPhysicsCalculator';
import SharedHelmet from '.././Helmet';
const TITLE = 'حواسب الفيزياء - حواسب مجانية لحساب زمن الوصول والمتر المكعب وكتلة الحديد والعدسات وكتلة الماء وحجم الغاز';
const DESCRIPTION = 'استكشف مجموعة حواسب الفيزياء المجانية، بما في ذلك حواسب زمن الوصول وحساب المتر المكعب وكتلة الحديد وقوة عدسة العين وكتلة الماء وحجم الغاز.';
const KEYWORDS = 'حواسب الفيزياء، حواسب مجانية، حاسبة زمن الوصول، حاسبة المتر المكعب، حاسبة قوة عدسة العين';
const OG_URL = 'https://do-calculate.com/ar/physics-calculators';
function CalculatorsList() {
    return (
        <div className="container rtl-container">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div  >
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-secondary" role="alert">
                    <p>{DESCRIPTION} </p>
                </div>
            </div>
            <hr/>
            <table >
                <thead>
                    <tr >
                        <th >الحاسبة</th>
                        <th >الوصف</th>
                    </tr>
                </thead>
                <tbody>
                    {physicsCalculators.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}
export default CalculatorsList;
